import { lazy } from 'react';
import { authRoles } from 'app/auth';

const Customer = lazy(() => import('./customer/Customer'));
const Employee = lazy(() => import('./employee/Employee'));
const Supplier = lazy(() => import('./supplier/Supplier'));

const ClientAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.staff,
  routes: [
    {
      path: 'customers/:customerId',
      element: <Customer />,
    },
    {
      path: 'employees/:employeeId',
      element: <Employee />,
    },
    {
      path: 'suppliers/:supplierId',
      element: <Supplier />,
    },
  ],
};

export default ClientAppConfig;
